<template>
  <div class="">
      <Widget>
        <h3>Completed <span class="fw-semi-bold">Checkups</span></h3>
        <p>
          History for completed patient checkups
        </p>
        <div class="table-responsive">
          <table class="table table-lg mb-0 requests-table table-hover">
            <thead>
            <tr class="text-muted">
              <th width="20%"><span class="fw-bold">Date & Time</span></th>
              <th width="45%"><span class="fw-bold">Patient</span></th>
              <th width="20%"><span class="fw-bold">Amount</span></th>
              <th width="15%"><span class="fw-bold">Action(s)</span></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="patientcheckup in patientcheckups" :key="patientcheckup.id">
              <td>{{ patientcheckup.start_time }}</td>
              <td>
                <span><b>{{
                    patientcheckup.patient.name
                  }}</b> [{{ JSON.parse(patientcheckup.checkupprescription.contents).disease_description }}]</span>
              </td>
              <td>{{ patientcheckup.amount }}</td>
              <td>
                <b-button variant="outline-info" size="sm" @click="openCheckupDetailsModal(patientcheckup)">
                  Details
                  <b-modal v-model="showDetailsModal">
                    <CheckupDetailsModal :patientcheckup="selectedPatientCheckup"/>
                  </b-modal>
                </b-button>
                <b-button variant="outline-success"  size="sm"  @click="downloadCheckupPrescription(patientcheckup.checkupprescription.id)">
                  Prescription
                </b-button>
              </td>
            </tr>
            </tbody>
          </table>

        </div>
        <b-pagination
            v-model="currentPage"
            :total-rows="tableRows"
            :per-page="perPage"
            first-number
            align="center"
            pills
        ></b-pagination>
      </Widget>
  </div>
</template>

<script>

// import historymock from "@/pages/doctor/History/historymock";
import AppointmentService from '@/services/doctor/appointment.service';
import CheckupDetailsModal from "@/components/admin/CheckupHistory/CheckupDetailsModal";

export default {

  name: "CheckupHistory",
  components: { CheckupDetailsModal },
  props: ['doctor'],
  data() {
    return {
      // historymock
      showDetailsModal: false,
      currentPage: 1,
      tableRows: 100,
      perPage: 5,
      selectedPatientCheckup: null,
      patientcheckups: []
    };
  },
  computed: {
  },
  methods: {
    fetchCheckupHistory() {
      AppointmentService.fetchDoctorCheckupHistory(this.doctor.id, this.currentPage)
          .then((response) => {
            if (response.status === 200) {
              this.perPage = response.data.per_page;
              this.tableRows = response.data.total;
              this.patientcheckups = response.data.data;
              // console.log("here");
              // console.log(this.patientcheckups);
            }
          })
    },
    openCheckupDetailsModal(patientcheckup){
      this.selectedPatientCheckup = patientcheckup;
      this.showDetailsModal = true;
    },
    downloadCheckupPrescription(checkupprescription_id) {
      AppointmentService.fetchCheckupPrescriptionFile(checkupprescription_id)
          .then(response => {
            if (response.status === 200) {
              let blob = new Blob([response.data], {type: 'application/pdf'})
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = 'test.pdf'
              link.click()
            }
          })
          .catch(error => {
            console.log(error);
          });
    }
  },
  mounted() {
    this.fetchCheckupHistory();
  }
}

</script>

<style scoped>

</style>
